import { useEffect } from 'react';

interface Props {
  title: string;
  body?: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * In-app confirmation.
 *
 * Not window.confirm(): iOS blocks it inside an installed PWA, so a destructive
 * action would either silently do nothing or silently proceed depending on the
 * return value. Neither is acceptable for "end the session".
 */
export default function ConfirmDialog({
  title, body, confirmLabel = 'Confirm', danger, onConfirm, onCancel,
}: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
      if (e.key === 'Enter') onConfirm();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onConfirm, onCancel]);

  return (
    <div className="overlay" style={{ zIndex: 80 }}
         onClick={e => e.target === e.currentTarget && onCancel()}>
      <div className="modal" role="alertdialog" aria-label={title} style={{ maxWidth: 400 }}>
        <h2>{title}</h2>
        {body && <p className="sub">{body}</p>}
        <div className="modal-actions">
          <button className="btn" onClick={onCancel} autoFocus>Cancel</button>
          <button className={danger ? 'btn danger' : 'btn primary'} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
